
import { Component, Prop, Vue } from "vue-property-decorator";
import { systemSrv } from "./../services/system";
import router from "@/router";
import { cacheSrv } from "./../services/cache";
import store from "./../store";
import axios from "axios";
import Datepicker from "vuejs-datepicker";
import { notiSrv } from "./../services/noti";

@Component({
  components: { Datepicker }
})
export default class SmartParkingForm extends Vue {
  memberAPIUrl = this.$store.getters.config.memberAPIUrl;
  CACHE_KEY_TOKEN = store.getters.tokenKeys.CACHE_KEY_TOKEN;
  MAX_PLATES = 2
  formData: any = {
    activeCar: 0,
    iuList: [
      {
        id: "1",
        vehicleNo: ""
      },
      {
        id: "2",
        vehicleNo: ""
      }
      // ,
      // {
      //   id: "3",
      //   vehicleNo: ""
      // },
      // {
      //   id: "4",
      //   vehicleNo: ""
      // }
    ]
  };
  processing = false;
  loadedForm = false;
  errorMessage = "";
  constructor() {
    super();
  }
  async created() {
    window.scrollTo(0, 0);
    //let notiId = notiSrv.sayNoti("Loading smart parking", 3000);
    await this.load();
    //notiSrv.destroy(notiId);
  }
  activate(index) {
    this.formData.activeCar = index;
    if (this.formData.iuList && this.formData.iuList.length > 0) {
      this.formData.iuList.forEach(itm => {
        itm.activate = false;
      });
      this.formData.iuList[this.formData.activeCar].activate = true;
      this.update();
    }
  }
  adjustIUListTo4(iuList) {
    if (iuList) {
      this.formData.activeCar = iuList.findIndex(itm => itm.activate);
      if (this.formData.activeCar < 0) {
        this.formData.activeCar = 0;
      }
      let diff = this.MAX_PLATES - iuList.length;
      if (diff > 0) {
        for (let index = 0; index < diff; index++) {
          const element = {
            id: iuList.length + index,
            vehicleNo: ""
          };
          iuList.push(element);
        }
      }
    }
    return iuList;
  }
  async load() {
    let data = await systemSrv.getIU();
    this.loadedForm = true;

    console.log("dataaaa", data);
    if (data && data.iuList) {
      this.formData.iuList = this.adjustIUListTo4(data.iuList);
    } else {
      console.log("no data. first time?");
    }
  }
  uniq(a, param) {
    return a.filter(function(item, pos, array) {
      return (
        array
          .map(function(mapItem) {
            return mapItem[param];
          })
          .indexOf(item[param]) === pos
      );
    });
  }
  async update() {
    this.processing = true;
    let token = cacheSrv.cached(this.CACHE_KEY_TOKEN);
    if (!token) {
      console.log("No token");
      router.push("login");
      return;
    }
    try {
      if (!this.formData.iuList) {
        this.errorMessage = "One or more Car Plates is required";
        return;
      }
      let iuList = this.formData.iuList
        .filter(itm => itm.vehicleNo)
        .map(itm => {
          return {
            iu: (itm.vehicleNo ? itm.vehicleNo.toUpperCase().replace(/\s/g,'') : itm.vehicleNo),
            vehicleNo: (itm.vehicleNo
              ? itm.vehicleNo.toUpperCase().replace(/\s/g,'')
              : itm.vehicleNo),
            activate: false
          };
        });
      iuList = this.uniq(iuList, "vehicleNo");
      if (!this.formData.activeCar || this.formData.activeCar < 0) {
        this.formData.activeCar = 0;
      }
      if (iuList && iuList.length > 0) {
        if (this.formData.activeCar >= iuList.length) {
          this.formData.activeCar = 0;
        }
        iuList[this.formData.activeCar].activate = true;
      }

      let payload = Object.assign({}, { iuList: iuList });

      let data = await systemSrv.activateIU(payload);
      this.processing = false;
      if (data) {
        if (data["error"]) {
          console.log("Error activating IU");
          this.errorMessage = data["meta"].original.error.message;
          return;
        }
        if (data.iuList) {
          this.formData.iuList = this.adjustIUListTo4(data.iuList);
        }
        let notiId = notiSrv.sayNoti("Car plates updated", 2000);
      } else {
        console.log("Error in activating IUe. No data");
      }
    } catch (error) {
      console.log("Error while activating IU. ", error);
      this.errorMessage = "Error while activating IU. " + error.error;
    }
  }
}
